import { render, staticRenderFns } from "./WrittenAnswers.vue?vue&type=template&id=0fcd8122&scoped=true&"
import script from "./WrittenAnswers.vue?vue&type=script&lang=js&"
export * from "./WrittenAnswers.vue?vue&type=script&lang=js&"
import style0 from "./WrittenAnswers.vue?vue&type=style&index=0&id=0fcd8122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcd8122",
  null
  
)

export default component.exports